import { gql } from "@apollo/client";

/**
 * QUERIES
 * */

export const GET_QUIZ_QUESTIONS = gql`
  query AllQuizQuestions {
    allQuizQuestions {
      id
      isEnabled
      isSlider
      maxAnswers
      description
      sortOrder
      quizVersion {
        id
      }
      quizanswerSet {
        id
        description
        graphicalIdentifier
        sortOrder
        quizAnswerCategory {
          id
        }
      }
    }
  }
`;

export const GET_QUIZ_STATISTICS = gql`
  query QuizStatistics($memberId: Int) {
    quizStatistics(memberId: $memberId) {
      totalSimilarMembers
      similarityPercentage
      palateDescription
    }
  }
`;

/**
 * BEER QUIZ
 * */

export const GET_BEER_QUIZ_QUESTIONS = gql`
  query BeerQuizQuestions {
    beerQuizQuestions {
      id
      description
      sortOrder
      inputType
      maxAnswers
      answers {
        id
        description
        subtext
        sortOrder
        graphicalIdentifier
      }
    }
  }
`;

export const SUBMIT_BEER_QUIZ = gql`
  mutation SubmitBeerQuiz($input: SubmitBeerQuizInput!) {
    submitBeerQuiz(input: $input) {
      isSuccessful
      assignedAddOnId
      memberId
      errors {
        messages
        field
      }
    }
  }
`;

export const GET_BEER_BOX_ADDONS = gql`
  query BeerBoxAddons($category: String) {
    allAddOns(category: $category) {
      id
      name
      shortName
      productMinPrice
      settingsHelpText
      memberSubscriptionAddOn {
        status
      }
    }
  }
`;

export const GET_BEER_QUIZ_MEMBER_STATE = gql`
  query BeerQuizMemberState {
    me {
      id
      firstName
      subscription {
        id
        subscriptionStatus {
          id
        }
      }
      shoppingCart {
        id
        discountCode
      }
      winequantitySet {
        numberOfBottles
        wineClass {
          id
        }
        winePriceRange {
          id
        }
      }
    }
  }
`;

/**
 * MUTATIONS
 * */

export const SUBMIT_QUIZ = gql`
  mutation SubmitQuiz($input: SubmitQuizInput!) {
    submitQuiz(input: $input) {
      isSuccessful
      accessToken
      refreshToken
      memberId
      errors {
        messages
        field
      }
    }
  }
`;
